import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";

import {CopyToClipboard} from 'react-copy-to-clipboard';

import {
    Layout,
    Row,
    Col,
    Switch,
    Button,
    Menu,
    Dropdown,
    Modal,
    notification
} from 'antd';

import {
    FiX,
    FiPlus,
    FiShield,
    FiLock,
    FiAlignRight,
    FiArrowRight,
    FiArrowLeft,
    FiAlignLeft,
    FiLogOut,
    FiCopy,
    FiSun,
    FiMoon
} from "react-icons/fi";

import {
    FaWallet,
    FaRocket
} from 'react-icons/fa';

import { icon_networks } from '../../assets/images/index';
import Logo from '../../assets/images/logo.svg';
import Metamask_Icon from '../../assets/images/metamask-icon.png';
import Wallet_Icon from '../../assets/images/icons/walletconnect.svg';

import { useWeb3React } from "@web3-react/core";
import { connectors } from "./../../utils/connectors";
import { toHex } from "./../../utils/utils";
import { networkParams } from "./../../utils/networks";

const { Header } = Layout;

const menu = (defaultTheme) => (
    <Menu
        className="nav-dropdown-dark"
        data-theme={defaultTheme}
        items={[
            {
                key: '1',
                label: (
                    <Link className="nav-item-icon" to="/create-presale">
                        <div className="icon">
                            <FaRocket />
                        </div>
                        PreSales
                    </Link>
                )
            },
            {
                key: '2',
                label: (
                    <Link className="nav-item-icon" to="/create-token-lock">
                        <div className="icon">
                            <FiLock />
                        </div>
                        Token Lock
                    </Link>
                )
            },
            {
                key: '3',
                label: (
                    <Link className="nav-item-icon" to="/create-locks">
                        <div className="icon">
                            <FiShield />
                        </div>
                        Liquidity Lock
                    </Link>
                )
            }
        ]}
    />
);

const openNotificationCopy = (type, defaultTheme) => {
    notification[type]({
        message: 'Copied address',
        closeIcon: <FiX />,
        // duration: 10000,
        className: defaultTheme === "dark" ? "notification-light" : "notification-dark",
    });
};

const HeaderPage = (props) => {
    // show menu account
    const menu_account = (defaultTheme) => {
        return(
            <Menu
                className="nav-dropdown-dark"
                data-theme={defaultTheme}
                items={[
                    {
                        key: '1',
                        label: (
                            <div className="nav-item-icon" onClick={() =>setIsModalAccountVisible(true)}>
                                <div className="icon">
                                    <FaWallet />
                                </div>
                                Wallet
                            </div>
                        )
                    },
                    {
                        key: '2',
                        label: (
                            <div className="nav-item-icon" onClick={() => props.disconnect()}>
                                <div className="icon">
                                    <FiLogOut />
                                </div>
                                Disconnect
                            </div>
                        )
                    }
                ]}
            />
        )
    }

    // copy address acount
    const [copied, setCopied] = useState(false);
    const handCopied = () => {
        setCopied(!copied);
        openNotificationCopy('success', props.defaultTheme);
    }

    const {
        library,
        activate,
        active,
        chainId,
        account,

    } = useWeb3React();

    const [network, setNetwork] = useState(typeof window.ethereum !== 'undefined' ? window.ethereum.networkVersion : 56);
    const [error, setError] = useState("");

    const setProvider = (type) => {
        window.localStorage.setItem("provider", type);
    };

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalAccountVisible, setIsModalAccountVisible] = useState(false);
    const [isModalConnectVisible, setIsModalConnectVisible] = useState(false);
    const [size, setSize] = useState('large');
    const [isNetWork, setIsNetWork] = useState(
        {
            icon: icon_networks.icon_network_56,
            name: 'BNB Smart Chain'
        }
    );
    const [isProfile, setIsProfile] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    }

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const showModalConnect = () => {
        setIsModalConnectVisible(true);
    };

    const handleCancelModalConnect = () => {
        setIsModalConnectVisible(false);
    };

    useEffect(async () => {
        await subscribeProvider();
        console.log(toHex(137))
    }, []);


    const subscribeProvider = async () => {
        if (typeof window.ethereum !== 'undefined') {
            window.ethereum.on("networkChanged", async (networkId) => {
                if (networkId == 1) {
                    setIsNetWork({
                        icon: icon_networks.icon_network_1,
                        name: 'Ethereum'
                    })
                }
                if (networkId == 56) {
                    setIsNetWork({
                        icon: icon_networks.icon_network_56,
                        name: 'BNB Smart Chain'
                    })
                }
                if (networkId == 97) {
                    setIsNetWork({
                        icon: icon_networks.icon_network_97,
                        name: 'BNB Smart Chain Testnet'
                    })
                }
                if (networkId == 137) {
                    setIsNetWork({
                        icon: icon_networks.icon_network_137,
                        name: 'Polygon Mainnet'
                    })
                }
                if (networkId == 43114) {
                    setIsNetWork({
                        icon: icon_networks.icon_network_43114,
                        name: 'Avalanche C-Chain'
                    })
                }
                if (networkId == 250) {
                    setIsNetWork({
                        icon: icon_networks.icon_network_250,
                        name: 'Fantom'
                    })
                }
            });

            window.ethereum.on('chainChanged', async (chainId) => {
                //  console.log(chainId)
            });
        }
    };

    const switchETHNetwork = async () => {
        if (typeof account != 'undefined') {
            try {
                await library.currentProvider.request({
                    method: "wallet_switchEthereumChain",
                    params: [{ chainId: toHex(1) }]
                });
                activate(connectors.injected);
                setIsModalVisible(false);
            } catch (switchError) {
                if (switchError.code === 4902) {
                    try {
                        await library.currentProvider.request({
                            method: "wallet_addEthereumChain",
                            params: [networkParams[toHex(1)]]
                        });
                        setNetwork(1);
                        setIsNetWork({
                            icon: icon_networks.icon_network_1,
                            name: 'Ethereum'
                        })
                        activate(connectors.injected);
                        setIsModalVisible(false);
                    } catch (error) {
                        setError(error);
                    }
                }
            }
        } else {
            setNetwork(1);
            setIsNetWork({
                icon: icon_networks.icon_network_1,
                name: 'Ethereum'
            })
            if (typeof window.ethereum !== 'undefined') {

                if (window.ethereum.networkVersion == 1) {
                    activate(connectors.injected);

                } else {

                    try {

                        await window.ethereum.request({
                            method: 'wallet_switchEthereumChain',
                            params: [{ chainId: toHex(1) }]
                        });

                        setNetwork(1);
                        setIsNetWork({
                            icon: icon_networks.icon_network_1,
                            name: 'Ethereum'
                        })
                        activate(connectors.injected);
                    } catch (error) {
                        setError(error);
                    }
                }
                setIsModalVisible(false);
            }
        }
    };

    const switchBNBNetwork = async () => {
        if (typeof account != 'undefined') {
            try {
                await library.currentProvider.request({
                    method: "wallet_switchEthereumChain",
                    params: [{ chainId: toHex(56) }]
                });
                activate(connectors.injected);
                setIsModalVisible(false);
            } catch (switchError) {
                if (switchError.code === 4902) {
                    try {

                        await library.currentProvider.request({
                            method: "wallet_addEthereumChain",
                            params: [networkParams[toHex(56)]]
                        });

                        setNetwork(56);
                        setIsNetWork({
                            icon: icon_networks.icon_network_56,
                            name: 'BNB Smart Chain'
                        })
                        activate(connectors.injected);
                        setIsModalVisible(false);
                    } catch (error) {
                        setError(error);
                    }
                }
            }
        } else {
            setNetwork(56);

            setIsNetWork({
                icon: icon_networks.icon_network_56,
                name: 'BNB Smart Chain'
            })

            if (typeof window.ethereum !== 'undefined') {
                if (window.ethereum.networkVersion == 56) {
                    activate(connectors.injected);
                } else {

                    try {

                        await window.ethereum.request({
                            method: 'wallet_switchEthereumChain',
                            params: [{ chainId: toHex(56) }]
                        });

                        setNetwork(56);
                        setIsNetWork({
                            icon: icon_networks.icon_network_56,
                            name: 'BNB Smart Chain'
                        })
                        activate(connectors.injected);
                    } catch (error) {
                        setError(error);
                    }
                }
                setIsModalVisible(false)
            }
        }
    };

    const switchBNBTestnetNetwork = async () => {
        if (typeof account != 'undefined') {
            try {
                await library.currentProvider.request({
                    method: "wallet_switchEthereumChain",
                    params: [{ chainId: toHex(97) }]
                });               
                activate(connectors.injected);
                setIsModalVisible(false);
            } catch (switchError) {
                if (switchError.code === 4902) {
                    try {
                        await library.currentProvider.request({
                            method: "wallet_addEthereumChain",
                            params: [networkParams[toHex(97)]]
                        });
                        setNetwork(97);
                        setIsNetWork({
                            icon: icon_networks.icon_network_97,
                            name: 'BNB Smart Chain Testnet'
                        })
                        activate(connectors.injected);
                        setIsModalVisible(false);
                    } catch (error) {
                        setError(error);
                    }
                }
            }
        } else {
            setNetwork(97);
            setIsNetWork({
                icon: icon_networks.icon_network_97,
                name: 'BNB Smart Chain Testnet'
            })
            if (typeof window.ethereum !== 'undefined') {
                if (window.ethereum.networkVersion == 97) {
                    activate(connectors.injected);
                } else {
                    try {
                        await window.ethereum.request({
                            method: 'wallet_switchEthereumChain',
                            params: [{ chainId: toHex(97) }]
                        });
                        setNetwork(97);
                        setIsNetWork({
                            icon: icon_networks.icon_network_97,
                            name: 'BNB Smart Chain Testnet'
                        })
                        activate(connectors.injected);
                    } catch (error) {
                        setError(error);
                    }
                }
                setIsModalVisible(false)
            }
        }
    };

    const handleWalletConnect = async () => {
        var walletconnectchain;
        switch (parseInt(network)) {
            case 1:
                walletconnectchain = connectors.walletconnect1;
                setNetwork(1);
                setIsNetWork({
                    icon: icon_networks.icon_network_1,
                    name: 'Ethereum'
                })
                break;
            case 56:
                walletconnectchain = connectors.walletConnect56;
                setNetwork(56);
                setIsNetWork({
                    icon: icon_networks.icon_network_56,
                    name: 'BNB Smart Chain'
                })
                break;
            case 97:
                walletconnectchain = connectors.walletConnect97;
                setNetwork(97);
                setIsNetWork({
                    icon: icon_networks.icon_network_97,
                    name: 'BNB Smart Chain Testnet'
                })
                break;
            case 137:
                walletconnectchain = connectors.walletconnect137;
                setNetwork(137);
                setIsNetWork({
                    icon: icon_networks.icon_network_137,
                    name: 'Polygon Mainnet'
                })
                break;
            default:
                walletconnectchain = connectors.walletConnect56;
                break;
        }
        activate(walletconnectchain);
        setProvider(String("walletConnect" + network));
        setIsModalConnectVisible(false);
    }


    const handleInjected = async () => {

        if (typeof window.ethereum !== 'undefined') {
            const currentNetwork = window.ethereum.networkVersion;
            switch (parseInt(currentNetwork)) {
                case 1:
                    activate(connectors.injected1);
                    setNetwork(1);
                    setIsNetWork({
                        icon: icon_networks.icon_network_1,
                        name: 'Ethereum'
                    })
                    break;
                case 56:
                    activate(connectors.injected56);
                    setNetwork(56);
                    setIsNetWork({
                        icon: icon_networks.icon_network_56,
                        name: 'BNB Smart Chain'
                    })
                    break;
                case 97:
                    activate(connectors.injected97);
                    setNetwork(97);
                    setIsNetWork({
                        icon: icon_networks.icon_network_97,
                        name: 'BNB Smart Chain Testnet'
                    })
                    break;
                default:
                    break;
            }
            setProvider(String("injected" + currentNetwork));
            setIsModalConnectVisible(false);
        } else {
            window.open("https://metamask.io", '_blank');
        }

    }

    const handleWalletLinkConnect = () => {
        var waterlinkconnectchain;
        switch (parseInt(network)) {
            case 1:
                waterlinkconnectchain = connectors.coinbaseWallet1;
                setNetwork(1);
                setIsNetWork({
                    icon: icon_networks.icon_network_1,
                    name: 'Ethereum'
                })
                break;
            case 56:
                waterlinkconnectchain = connectors.coinbaseWallet56;
                setNetwork(56);
                setIsNetWork({
                    icon: icon_networks.icon_network_56,
                    name: 'BNB Smart Chain'
                })
                break;
            case 97:
                waterlinkconnectchain = connectors.coinbaseWallet97;
                setNetwork(97);
                setIsNetWork({
                    icon: icon_networks.icon_network_97,
                    name: 'BNB Smart Chain Testnet'
                })
                break;
            case 137:
                waterlinkconnectchain = connectors.coinbaseWallet137;
                setNetwork(137);
                setIsNetWork({
                    icon: icon_networks.icon_network_137,
                    name: 'Polygon Mainnet'
                })
                break;
            default:
                waterlinkconnectchain = connectors.coinbaseWallet56;
                break;
        }
        activate(waterlinkconnectchain);
        setProvider(String("coinbaseWallet" + network));
        setIsModalConnectVisible(false);
    }

    return (
        <>
            <Header
                className="header-dashboard"
            >
                <div className="header-dashboard-wrap">
                    <div className="header-dashboard-left">
                        <div className="header-logo-wrap">
                            <div className="logo">
                                <Link to="/">
                                    <img className="logo-landing" src={Logo} alt="" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="header-dashboard-right">
                        <div className="nav-toogle-sidebar">
                            {React.createElement(props.collapsed ? FiAlignLeft : FiAlignRight, {
                                className: 'trigger',
                                onClick: props.openLeftMenuCallBack,
                            })}
                        </div>
                        <div className="header-group">
                            <div className="toggle-theme-wrapper">
                                {React.createElement(props.defaultTheme === "light" ? FiSun : FiMoon, {
                                    className: 'trigger',
                                    onClick: props.switchThemeCallBack,
                                })}
                            </div>
                            <Dropdown overlay={menu(props.defaultTheme)} placement="bottomLeft">
                                <Button className="btn-primary-outline btn-mobile" type="primary" shape="round" ><FiPlus /> Create</Button>
                            </Dropdown>
                            <Button className="btn-choose__network btn-mobile" type="primary" shape="round" size={size} onClick={showModal}>
                                <img className="icon" src={isNetWork.icon} alt="" />
                                <span>{isNetWork.name}</span>
                            </Button>
                            {!active && typeof account == 'undefined' ? (
                                <Button className="btn-connect__network btn-mobile" type="primary" shape="round" size={size} onClick={showModalConnect}>
                                    <img src={Metamask_Icon} alt="" />
                                    <span>Connect Wallet</span>
                                </Button>
                            ) : (
                                <Dropdown overlay={menu_account(props.defaultTheme)} placement="bottomLeft" trigger={['click']}>
                                    <Button className="btn-connect__network" type="primary" shape="round" size={size}>
                                        <FaWallet />
                                        <span>
                                            {`${account.slice(0, 6)}...${account.slice(
                                                account.length - 4,
                                                account.length
                                            )}`}
                                        </span>
                                    </Button>
                                </Dropdown>
                            )}
                        </div>
                    </div>
                </div>
                {/* <Row justify="space-between" align="middle">
                    <Col xs={12} sm={4} md={6} lg={4} xl={3}>
                        <div className="header-logo-wrap">
                            <div className="logo">
                                <Link to="/dashboard">
                                    <img className="logo-landing" src={Logo} alt="" />
                                </Link>
                            </div>
                            <div className="nav-toogle-sidebar">
                                {React.createElement(props.collapsed ? FiArrowLeft : FiArrowRight, {
                                    className: 'trigger',
                                    onClick: props.openLeftMenuCallBack,
                                })}
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} sm={4} md={4} lg={12} xl={12}>
                        <div className="header-group">
                            <Dropdown overlay={menu} placement="bottomLeft">
                                <Button className="btn-primary-outline btn-mobile" type="primary" shape="round" ><FiPlus /> Create</Button>
                            </Dropdown>
                            <Button className="btn-choose__network btn-mobile" type="primary" shape="round" size={size} onClick={showModal}>
                                <img className="icon" src={isNetWork.icon} alt="" />
                                <span>{isNetWork.name}</span>
                            </Button>
                            {!active && typeof account == 'undefined' ? (
                                <Button className="btn-connect__network btn-mobile" type="primary" shape="round" size={size} onClick={showModalConnect}>
                                    <img src={Metamask_Icon} alt="" />
                                    <span>Connect Wallet</span>
                                </Button>
                            ) : (
                                <Dropdown overlay={menu_account} placement="bottomLeft" trigger={['click']}>
                                    <Button className="btn-connect__network" type="primary" shape="round" size={size}>
                                        <FaWallet />
                                        <span>
                                            {`${account.slice(0, 6)}...${account.slice(
                                                account.length - 4,
                                                account.length
                                            )}`}
                                        </span>
                                    </Button>
                                </Dropdown>
                            )}
                        </div>
                    </Col>
                </Row> */}

            </Header>

            <Modal
                visible={isModalConnectVisible}
                onCancel={handleCancelModalConnect}
                closeIcon={<FiX />}
                title="Connect to a wallet"
                centered={true}
                footer=""
                className="modal-choose-network"
                data-theme={props.defaultTheme}
            >
                <div className="connect-wallet-wrap">
                    <div className="switch_wallet_network">
                        <div className="switch_network_item"
                            onClick={() => handleInjected()}
                        >
                            <img src={Metamask_Icon} alt="" />
                            <span>MetamaskMetamask</span>
                        </div>
                        <div className="switch_network_item"
                            onClick={() => handleWalletConnect()}
                        >
                            <img src={Wallet_Icon} alt="" />
                            <span>WalletConnect</span>
                        </div>                      
                        {/* <div className="switch_network_item"
                            onClick={() => {
                                handleWalletLinkConnect()
                            }}
                        >
                            <img src={icon_networks.icon_network_1} alt="" />
                            <span>Coinbase</span>
                        </div> */}
                    </div>
                    <div className="faq-connect">
                        <Button type="link" danger>
                            <span>Haven’t got a crypto wallet yet?</span>
                        </Button>
                        <Button className="align-items-center" type="primary" shape="round" size={size}>
                            <span>Learn How to Connect</span>
                        </Button>
                    </div>
                </div>
            </Modal>

            <Modal
                title="Choose network"
                visible={isModalVisible}
                data-theme={props.defaultTheme}
                onCancel={handleCancel}
                closeIcon={<FiX />}
                centered={true}
                footer=""
                className="modal-choose-network"
            // style={{backgroundImage: `url(${background_modal.bg_modal})`}}
            >

                <div className="switch_network_wrap" >
                    <span className="network-title">Mainnet</span>
                    <div className="switch_network_form">
                        <div className="switch_network_item"
                            // key={index}
                            onClick={() => switchETHNetwork()}
                        >
                            <img src={icon_networks.icon_network_1} alt="" />
                            <span>Ethereum</span>
                        </div>
                        <div className="switch_network_item"
                            // key={index}
                            onClick={() => switchBNBNetwork()}
                        >
                            <img src={icon_networks.icon_network_56} alt="" />
                            <span>BNB Smart Chain</span>
                        </div>
                    </div>

                    <span className="network-title">Testnet</span>
                    <div className="switch_network_form">
                        <div className="switch_network_item"
                            // key={index}
                            onClick={() => switchBNBTestnetNetwork()}
                        >
                            <img src={icon_networks.icon_network_97} alt="" />
                            <span>BNB Smart Chain Testnet</span>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Modal account */}

            <Modal
                visible={isModalAccountVisible}
                onCancel={() => setIsModalAccountVisible(false)}
                data-theme={props.defaultTheme}
                closeIcon={<FiX />}
                title="Your wallet"
                centered={true}
                footer=""
                className="modal-choose-network"
            >
                <div className="account-wallet-wrap">
                    <span className="text-white">Your address</span>
                    <div className="acount-wallet-item">
                        <span className="text-primary">{account}</span>
                        <CopyToClipboard 
                            text={account}
                            onCopy={() => handCopied()}
                        >
                            <span className="text-primary">
                                <FiCopy />
                            </span>
                        </CopyToClipboard>
                    </div>
                    <div className="box-view tetx-center text-primary">
                        View on <a>https://bscscan.com</a>
                    </div>
                    <div className="faq-connect">
                        <Button className="d-flex align-items-center btn-primary" type="primary" shape="round" size={size} onClick={
                            () => {
                                props.disconnect();
                                setIsModalAccountVisible(false);
                            }
                        }>
                            <FiLogOut />
                            <span>Disconnect Wallet</span>
                        </Button>
                    </div>
                </div>
              
            </Modal>
        </>
    );
}

export default HeaderPage;
